import React from 'react';
import { observer } from 'mobx-react-lite';
import { useIntl } from 'react-intl';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import CreditCardShape from '../definitions/CreditCardShape';
import FooterDefaultIntlFormatValues from '../definitions/FooterDefaultIntlFormatValues';
import getInterestAndMinimumIncomeColumns from '../functions/getInterestAndMinimumIncomeColumns';
import CardFooter from './CardFooter';


function CardFooterBalanceTransfer({ cardInfo, ...otherProps }) {
    const intl = useIntl();

    const columns = [
        null,

        intl.formatMessage(COMMON_MESSAGES.cardFooterAnnualFee, {
            ...DefaultIntlFormatValues,
            ...FooterDefaultIntlFormatValues,
            ...cardInfo,
            zero: 0,
        }),

        ...getInterestAndMinimumIncomeColumns({
            purchaseInterest: cardInfo.purchaseInterest,
            cashAdvanceInterest: cardInfo.cashAdvanceInterest,
            balanceTransferInterest: cardInfo.balanceTransferInterest,

            minimumIncome: cardInfo.minimumIncome,
            minimumCreditScore: cardInfo.minimumCreditScore,
            intl,
        }),
    ];

    return (
        <CardFooter
            columns={columns}
            {...otherProps}
        />
    );
}

CardFooterBalanceTransfer.propTypes = {
    cardInfo: CreditCardShape.isRequired,
};


export default observer(CardFooterBalanceTransfer);
